import PropTypes from 'prop-types';
import React from 'react';

import useArticle from '../../hooks/use_article';
import useGroup from '../../hooks/use_group';
import useTranslation from '../../hooks/use_translation';
import GroupLink from '../framework/group_link';
import Trans from '../translation/trans';

const FaqMini = ({ children, include_groups, include_products }) => {
	let empty = true;
	const { items: groups_data } = useGroup({
		include_groups,
		include_types: ['article'],
	});
	const { items: articles } = useArticle({
		include_groups: groups_data?.map((item) => item.group_id),
		include_products,
		include_types: ['support'],
	});
	const { t } = useTranslation('component_faq_mini');

	if (!articles || !articles.length) return;
	const component = (
		<div className="faq">
			{groups_data.map((group, index1) => {
				if (
					!group.group_variant ||
					(group.group_variant.seo_title == '' &&
						(!include_groups || (include_groups && include_groups.length != 1)))
				) {
					return;
				}

				const article_list = articles
					.filter((article) => {
						if (article.groups.includes(group.group_id)) return true;
						return false;
					})
					.map((article, index2) => {
						if (empty) empty = false;

						return (
							<div className="accordion-item" key={index2}>
								<h2
									className="accordion-header"
									id={`header-${article.article_variant.article_variant_id}`}
								>
									<button
										aria-controls={`collapse-${article.article_variant.article_variant_id}`}
										aria-expanded="true"
										className="accordion-button collapsed"
										data-bs-target={`#collapse-${article.article_variant.article_variant_id}`}
										data-bs-toggle="collapse"
										type="button"
									>
										{article.article_variant.title}
									</button>
								</h2>
								<div
									aria-labelledby={`#header-${article.article_variant.article_variant_id}`}
									className="accordion-collapse collapse"
									data-bs-parent="#accordionFAQmini"
									id={`collapse-${article.article_variant.article_variant_id}`}
								>
									<div className="accordion-body text-muted">
										<p className="">
											<Trans defaults={article.article_variant.excerpt} t={t} />
										</p>
										<GroupLink
											article_id={article.article_id}
											className=""
											groups={article.groups}
											page="support"
										>
											{t('t1')}
										</GroupLink>
									</div>
								</div>
							</div>
						);
					});

				if (!article_list || !article_list.length) return;

				return (
					<div className="" key={index1}>
						{(!include_groups ||
							(include_groups && include_groups.length > 1)) && (
							<h2
								className="accordion-header base"
								id={`header-${group.group_variant.slug}`}
							>
								{group.group_variant.title}
							</h2>
						)}

						<div className="accordion accordion-flush" id="accordionFAQmini">
							{article_list}
						</div>
					</div>
				);
			})}
		</div>
	);

	return children ? <>{children(empty ? null : component)}</> : component;
};

FaqMini.propTypes = {
	children: PropTypes.any,
	include_groups: PropTypes.array,
	include_products: PropTypes.array,
};

export default FaqMini;
